import { useContext } from 'react';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import useGetUserTileInfo from '../useGetUserTileInfo';

function useTrackMegaUserInfo() {
  const trackEvent = useTrackEvent();
  const data = useGetUserTileInfo();

  const { resetKeywordSuggestion } = useContext(SearchEventsDataContext);

  const fireEvent = () => {
    trackEvent('mega-srp-user-info', data, undefined, {
      useFetch: true,
      fetchOption: { keepalive: false }
    });

    resetKeywordSuggestion();
  };

  return {
    data,
    fireEvent
  };
}

export default useTrackMegaUserInfo;
